/**
 * Sync-panel helpers for screenings import (aligned with engine importer rules).
 *
 * The tab label may interpolate `common.screening` / `places.place` (nouns only).
 * Full sentences live in locales / override-*.yml — do not interpolate those
 * nouns into prose (gender agreement).
 */

/**
 * Whether this import source also creates/updates places.
 *
 * JSON only syncs places when `places_key` is set; Kronos screenings never do.
 *
 * @param {{ source?: string, places_key?: string }|null|undefined} config
 * @returns {boolean}
 */
export function willSyncScreeningPlaces(config) {
    if (!config)
        return false;

    if (config.source === 'kronos')
        return false;

    if (config.source === 'json')
        return !!config.places_key?.length;

    return true;
}

/**
 * JSON / Eventival / Fiona / Kronos reapply pricings on update when the source
 * provides a list. OZU and Ciné.ch never do.
 *
 * @param {string|null|undefined} source
 * @returns {boolean}
 */
export function reapplyPricingsOnScreeningsUpdate(source) {
    return !['ozu', 'cinech'].includes(source);
}

/**
 * Tab label: the noun(s) only. Safe to interpolate because there is no
 * article / adjective / participle that must agree in gender.
 *
 * @param {function} t
 * @param {{ source?: string, places_key?: string }|null|undefined} config
 * @returns {string}
 */
export function screeningsSyncTabLabel(t, config) {
    const screenings = t('common.screening', { count: 42 });
    if (!willSyncScreeningPlaces(config))
        return screenings;

    return t('events.sync_screenings_tab_with_places', {
        screenings,
        places: t('places.place', { count: 42 }),
    });
}
